export const moveCaretToEnd = (el) => {
  if (el && typeof el.setSelectionRange === "function") {
    const len = el.value.length;
    el.setSelectionRange(len, len);
  }
};

export const formatWithTwoDecimals = (value) =>
  value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export function mapDataForMappingDetails(mappingDetails, data) {
  const result = {};
  for (const [dataKey, mappingKey] of Object.entries(mappingDetails)) {
    result[mappingKey] = data[dataKey] ?? null;
  }
  return result;
}
